module.exports = __webpack_public_path__ + "assets/83877024396e54dcee48d5c5b034c532.png";